module.exports = {"hiddenScaleDetailsTenantId":["1805087751369035778","1830808694326202370","1838818170987778050","1828738495150198786","999"]}


//////////////////
// WEBPACK FOOTER
// ./static/setting.json
// module id = quwt
// module chunks = 33